import { GetClubsByZoneResponse } from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { Stack, styled } from '@mui/material';
import { useEffect, useMemo, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import DirectAccessFooter from '../../components/Footer/DirectAccessFooter';
import { getCookie } from '../../utils/helpers';
import { Header } from './Components/Header';

const Main = styled('main')({ flex: 1, display: 'flex' });

const AuthLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authLayoutRef = useRef<HTMLDivElement>(null);
  const pathsThatDoNotCheckForZip = [
    '/club',
    '/conversion',
    '/simplified-registration',
    '/policy-zip',
    '/reset',
  ];
  const checkForZipCodeCookie = useMemo(
    () =>
      !pathsThatDoNotCheckForZip.find((path) =>
        location.pathname.includes(path)
      ),
    [location]
  );

  useEffect(() => {
    const mprZipCookie = getCookie('mpr_zip');
    const zipCodeCookie: GetClubsByZoneResponse | null = mprZipCookie
      ? JSON.parse(mprZipCookie)
      : null;

    if (!zipCodeCookie && checkForZipCodeCookie) {
      navigate('/policy-zip', { replace: true }); // force the user to set a zipcode if no cookie is found
    }
  }, []);

  useEffect(() => {
    if (authLayoutRef.current) {
      authLayoutRef.current?.focus();
    }
  }, [location]);

  return (
    <Stack
      data-testid="auth-layout"
      tabIndex={-1}
      ref={authLayoutRef}
      sx={{
        flexDirection: "column",
        minHeight: '100vh'
      }}>
      <Header />
      <Main>
        <Outlet />
      </Main>
      <DirectAccessFooter />
    </Stack>
  );
};

export default AuthLayout;
